export type FocusedDashboardMode = 'logistics' | 'tax_accountancy' | 'financial_services';

export interface DashboardModeOption {
  id: FocusedDashboardMode;
  label: string;
  description: string;
  icon: string;
}

/** The focused dashboards a plan can open from Full, in menu order. */
export const DASHBOARD_MODE_OPTIONS: ReadonlyArray<DashboardModeOption> = [
  {
    id: 'logistics', label: 'Logistics',
    description: 'Fleets, freight and supply chains', icon: 'fa-truck-fast',
  },
  {
    id: 'tax_accountancy', label: 'Tax & accountancy',
    description: 'Reliefs, advisers and filing signals', icon: 'fa-file-invoice',
  },
  {
    id: 'financial_services', label: 'Financial services',
    description: 'FX, lending, working capital and ownership', icon: 'fa-building-columns',
  },
];
